
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("7NOdL", function(module, exports) {

$parcel$export(module.exports, "ThemeQuery", () => $da1ccafc0c457033$export$ab00fc0363cea48f);

var $d2LG0 = parcelRequire("d2LG0");
const $da1ccafc0c457033$export$ab00fc0363cea48f = (0, $d2LG0.default)`query ThemeQuery{lookAndFeel{custom{horizontalHeader{backgroundColor primaryNavigation{highlightColor}}}}}`;

});

parcelRegister("3RlfX", function(module, exports) {

$parcel$export(module.exports, "TopNavigationQuery", () => $007d614b5ecf70db$export$31a318cd860f264b);
/** @graphql cc **/ 
var $d2LG0 = parcelRequire("d2LG0");
const $007d614b5ecf70db$export$31a318cd860f264b = (0, $d2LG0.default)`query TopNavigationQuery($includeNav4AdminOptIn:Boolean!){siteConfiguration{customSiteLogo}siteSettings{siteTitle showApplicationTitle isNav4OptedIn@include(if:$includeNav4AdminOptIn)}siteDescription{logoUrl}user:confluence_atlassianUser(current:true){id displayName emails{value isPrimary}photos{value}}}`;

});


//# sourceMappingURL=PageLayout.b6521555.js.map
